import { defineComponent, nextTick } from 'vue'
import anime from 'animejs/lib/anime.es.js'

const pushAnime = 'push-anime' // 前进动画名
const backAnime = 'back-anime' // 返回动画名
const replaceAnime = 'replace-anime' // 替换动画名
const fsTransitionAnimeName = 'fsTransitionAnime' // 存储字段名
const transitionWrapperSymbol = 'fs-transition-symbol' // 容器名class
const transitionBackgroundWrapperSymbol = 'fs-transition-background-symbol' // 容器名id
const animeDuration = 200 // 动画时间
let scrollPosition = { x: 0, y: 0 }
let pushAnimation: any
let actionAnime = pushAnime

interface IFrom {
  fullPath?: string
}

const Transition = defineComponent({
  name: 'FsTransition',
  inheritAttrs: false,
  setup(_props, { slots }) {
    // 设置回退动画钩子
    window.onpopstate = function () {
      setBackAnime()
    }

    return () => {
      return <div class={transitionWrapperSymbol}>{slots.default ? slots.default() : null}</div>
    }
  },
})

/**
 * @function 设置动画
 */
function _setAnime(anime = replaceAnime) {
  actionAnime = anime
}

/**
 * @function 获取动画名
 */
function _getAnime() {
  return actionAnime
}

/**
 * @function 设置替换动画
 */
function setReplaceAnime() {
  _setAnime(replaceAnime)
}

/**
 * @function 设置前进动画
 */
function setPushAnime() {
  _setAnime(pushAnime)
}

/**
 * @function 设置回退动画
 */
function setBackAnime() {
  _setAnime(backAnime)
}

/**
 * @function 设置进入动画
 */
function setEnterAnime(from: IFrom) {
  if (from.fullPath !== '/') {
    showBackground()
    const animeType = _getAnime()
    const direction = animeType === backAnime ? '-' : ''
    pushAnimation = anime({
      targets: `.${String(transitionWrapperSymbol)}`,
      keyframes:
        animeType === replaceAnime
          ? [
              { opacity: 0, translateZ: 0, duration: 0 },
              { opacity: 1, translateZ: 0, duration: animeDuration },
            ]
          : [
              {
                translateX: `${direction}${document.documentElement.clientWidth}`,
                translateZ: 0,
                duration: 0,
              },
              {
                translateX: 0,
                translateZ: 0,
                duration: animeDuration,
              },
            ],
      easing: 'easeInOutSine',
    })
    pushAnimation.finished.finally(() => {
      clearBackground()
      document.querySelector(`.${String(transitionWrapperSymbol)}`)?.removeAttribute('style')
      pushAnimation = null
    })
  }
}

/**
 * @function 设置离开动画
 */
function setLeaveAnime(from: IFrom) {
  return new Promise(resolve => {
    setPushAnime()
    if (from.fullPath !== '/') {
      if (!!pushAnimation) {
        pushAnimation.pause()
        document.querySelector(`.${String(transitionWrapperSymbol)}`)?.removeAttribute('style')
        pushAnimation = null
      }
      setBackground()
      const animation = anime({
        targets: `.${String(transitionWrapperSymbol)}`,
        keyframes: [
          { translateZ: 0, duration: 0 },
          { translateZ: 0, duration: 0 },
        ],
        easing: 'easeInOutSine',
      })
      animation.finished.finally(() => {
        document.querySelector(`.${String(transitionWrapperSymbol)}`)?.removeAttribute('style')
        resolve(true)
      })
    } else {
      resolve(true)
    }
  })
}

/**
 * @function 设置背景图片
 * @param canvas 背景图片
 */
function setBackground() {
  let bg = document.getElementById(transitionBackgroundWrapperSymbol)
  const page = document.querySelector(`.${String(transitionWrapperSymbol)}`)
  const pageChildren = page?.children
  page?.removeAttribute('style')
  if (!bg) {
    //不存在就插入
    const bgElement = document.createElement('div')
    bgElement.id = transitionBackgroundWrapperSymbol
    document.body.appendChild(bgElement)
    bg = bgElement
    bg.style.position = 'fixed'
    bg.style.zIndex = '-1'
    bg.style.top = '0'
    bg.style.width = '100vw'
    bg.style.height = '100vh'
    bg.style.overflow = 'hidden'
    bg.style.background = 'f8f8f8'
  }
  bg.style.display = 'none'
  bg.innerHTML = ''
  scrollPosition = { x: window.pageXOffset, y: window.pageYOffset }
  if (pageChildren && pageChildren.length > 0) {
    for (let index = 0; index < pageChildren.length; index++) {
      const element = pageChildren[index]
      bg && bg.appendChild(element.cloneNode(true))
    }
  }
}

/**
 * @function 显示背景图片
 * @param canvas 背景图片
 */
function showBackground() {
  let bg = document.getElementById(transitionBackgroundWrapperSymbol)
  if (bg) {
    bg.style.display = 'block'
    bg.scrollLeft = scrollPosition.x
    bg.scrollTop = scrollPosition.y
  }
}

/**
 * @function 清空背景图片
 * @param canvas 背景图片
 */
function clearBackground() {
  let bg = document.getElementById(transitionBackgroundWrapperSymbol)
  if (bg) {
    bg.style.display = 'none'
    bg.innerHTML = ''
  }
}

Transition.useTransition = function () {
  return {
    setReplaceAnime,
    setBackAnime,
    setEnterAnime,
    setLeaveAnime,
  }
}

export default Transition
